var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('app-header',{attrs:{"title":"Settings","tabs":_vm.tabs,"activeTabInd":_vm.activeTabIndex},on:{"activeTabChanged":_vm.setActiveTab}}),_c('v-main',{staticClass:"page-content"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }